import React, {Component} from 'react';
import './TabSet.css';

class TabSet extends Component {
	render() {
		return (
			<nav className="TabSet">
				{this.props.children}
			</nav>
		);
	}
}

export default TabSet;


// WEBPACK FOOTER //
// ./src/widgets/TabSet.js